export const environment = {
  name: 'production',
  production: true,
    auth: {
    url:
      'https://mb-fee-based-admin-ctvm-users.auth.us-east-1.amazoncognito.com',
    callbackUrl: 'https://fee-based-admin-ctvm.ctvm.montebravo.com.br/auth',
    region: 'us-east-1',
    userPoolId: 'us-east-1_mUoigZHiF',
    userPoolWebClientId: '4p3pcqb3rvgjelrdiuu5fdnvdp',
  },
  apiUrl: 'https://fee-based-admin.api.ctvm.montebravo.com.br',
  features: {
    /** Use here to define feature toggles */
  },
}
